import { ChangeDetectionStrategy, Component, inject, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { map, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { MainTabEnum } from '../../../enums/main-tabs';
import * as fromOfficeSelectors from '../../../store/selectors/office.selectors';
import * as fromWhiteLabelingSelectors from '../../../store/selectors/white-labeling.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-web-layout',
  standalone: false,
  styleUrls: ['./web-layout.component.scss'],
  templateUrl: './web-layout.component.html'
})
export class WebLayoutComponent {
  private ngZone = inject(NgZone);
  private router = inject(Router);
  private store = inject(Store);

  logoUrl = '/assets/logo.svg';

  activeTab: MainTabEnum = MainTabEnum.PropertySearch;
  availableTabs = MainTabEnum;

  calculatorsEnabled$: Observable<boolean>;
  netSheetEnabled$: Observable<boolean>;
  walkingFarmEnabled$: Observable<boolean>;
  contactCardEnabled$: Observable<boolean>;

  propertyNavigationEnabled$: Observable<boolean>;
  propertyNavigationWalkingFarmId: string | null = null;
  propertyNavigationPropertyId: string | null = null;

  constructor() {
    this.calculatorsEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectCalculatorsEnabled));
    this.netSheetEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectNetSheetsEnabled));
    this.walkingFarmEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectWalkingFarmEnabled));
    this.contactCardEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectContactCardEnabled));
    this.propertyNavigationEnabled$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => {
        const routeRegExp = /^\/walking-farm\/(?<farmId>.*)\/view\/property\/(?<propertyId>[^/]*)$/;
        const hasPropertyNavigation = routeRegExp.test(event.urlAfterRedirects);
        this.propertyNavigationWalkingFarmId = null;
        this.propertyNavigationPropertyId = null;
        if (hasPropertyNavigation) {
          const match = `${event.urlAfterRedirects}`.match(routeRegExp);
          if (match) {
            this.propertyNavigationWalkingFarmId = match[1];
            this.propertyNavigationPropertyId = match[2];
          }
        }
        return hasPropertyNavigation;
      })
    );
    this.store.pipe(select(fromWhiteLabelingSelectors.selectLogoUrl)).subscribe((logoUrl) => {
      this.ngZone.run(() => {
        this.logoUrl = logoUrl;
      });
    });
  }

  setCurrentTab(tab: MainTabEnum) {
    if (Object.values(MainTabEnum).includes(tab)) {
      this.activeTab = tab;
    } else {
      this.activeTab = MainTabEnum.PropertySearch;
    }
  }
}
